import { useAuth } from "../features/auth/hooks/use-auth";
import { mustChangePassword } from "../features/auth/utils/must-change-password";
import { CoreProvider } from "../shared/contexts/core-context";
import { AuthRoutes } from "./auth-routes";
import { OtherRoutes } from "./other-routes";

export function AppRoutes() {
	const { signed, user } = useAuth();

	return signed && !mustChangePassword(user) ? (
		<CoreProvider>
			<OtherRoutes />
		</CoreProvider>
	) : (
		<AuthRoutes />
	);
}
